(() => {
  const root = document.querySelector('[data-ls-trust-notices]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const items = Array.from(root.querySelectorAll('[data-ls-notice-item]')).map((item) => item.dataset);
  const card = root.querySelector('[data-ls-notice]');
  const link = root.querySelector('[data-ls-notice-link]');
  const image = root.querySelector('[data-ls-notice-image]');
  const title = root.querySelector('[data-ls-notice-title]');
  const text = root.querySelector('[data-ls-notice-text]');
  const close = root.querySelector('[data-ls-notice-close]');
  if (!items.length || !card || !link || !image || !title || !text || !close) return;

  let lastIndex = -1;
  let hideTimer;
  let nextTimer;

  const hide = () => {
    root.classList.remove('is-visible');
    window.clearTimeout(hideTimer);
  };

  const schedule = (delay = 26000) => {
    window.clearTimeout(nextTimer);
    nextTimer = window.setTimeout(show, delay);
  };

  const show = () => {
    let index = Math.floor(Math.random() * items.length);
    if (items.length > 1 && index === lastIndex) index = (index + 1) % items.length;
    lastIndex = index;

    const item = items[index];
    title.textContent = item.title || '';
    text.textContent = item.text || '';
    image.src = item.image || image.src;
    link.href = item.url || '#';

    root.hidden = false;
    window.requestAnimationFrame(() => root.classList.add('is-visible'));
    hideTimer = window.setTimeout(() => {
      hide();
      schedule();
    }, 5200);
  };

  close.addEventListener('click', () => {
    hide();
    window.clearTimeout(nextTimer);
    schedule(18000);
  });

  nextTimer = window.setTimeout(show, 2800);
})();

